import { isMobileDevice } from './index';

import type { ProfileItems } from '@avalara/types/analytics';

export const initializeDigitalData = (pageName: string) => {
  window.digitalData = {
    ...window.digitalData,
    page: {
      pageInfo: {
        pageName,
        channel: '',
        category: '',
        subCategory1: '',
        subCategory2: '',
        language: navigator.language,
        platform: isMobileDevice() ? 'MOBILE' : 'DESKTOP',
      },
    },
    user: {
      profileInfo: {
        isLoggedIn: 'NO',
        profileID: '',
        accountId: '',
      },
    },
  };
};

export const sendAnalyticsData = (eventTrack: string) => {
  if (window.digitalData && window._satellite && typeof window._satellite.track === 'function') {
    window._satellite.track(eventTrack);
  }
};

export const updateAnalyticsUser = (newProfileInfo: ProfileItems) => {
  if (window.digitalData) {
    const {
      user: { profileInfo: previousProfileInfo },
    } = window.digitalData;

    const profileInfo = {
      ...previousProfileInfo,
      ...newProfileInfo,
    };

    window.digitalData = {
      ...window.digitalData,
      user: {
        profileInfo,
      },
    };
  }
};

export const updateAnalyticsPage = (
  appName: string,
  mappingCallback: (arg0: string) => string = (v) => v,
  customPageName = '',
) => {
  if (window.digitalData) {
    const {
      page: { pageInfo },
    } = window.digitalData;
    const previousPageName = pageInfo.pageName;

    /* NOTE(Sasha): Both Integrations and Account store the pathname in
       location.hash. Account also contains /a/{AccountId}, which should be
       removed to ensure proper capture of the location path. */
    const pathName = window.location.hash !== '' ? window.location.hash : window.location.pathname;
    let pathArray =
      pathName !== ''
        ? (pathName
            ?.split('?')[0]
            ?.split('/')
            ?.slice(1)
            ?.filter((s) => s.length > 0) ?? [])
        : [];

    if (pathArray[0] === 'a') {
      pathArray = pathArray.slice(2);
    }
    pageInfo.pageName =
      customPageName !== ''
        ? customPageName
        : [appName.toLowerCase(), mappingCallback(pathArray.length > 0 ? pathArray[pathArray.length - 1] : '')]
            .filter((s) => s.length > 0)
            .map((s) => s.trim())
            .join(' | ');
    pageInfo.channel = appName.toLowerCase();
    pageInfo.category = pathArray[0] ? pathArray[0] : '';
    pageInfo.subCategory1 = pathArray[1] ? pathArray[1] : '';
    pageInfo.subCategory2 = pathArray.length > 2 ? pathArray.slice(2).join('-') : '';

    window.digitalData = {
      ...window.digitalData,
      page: {
        pageInfo,
      },
    };
    if (previousPageName !== pageInfo.pageName) {
      sendAnalyticsData('page_view');
    }
  }
};

export const setErrorPageAnalytics = (errorCode: number, errorPageName: string) => {
  if (window.digitalData && window.s) {
    window.s.pageType = 'errorPage';
    window.digitalData.page.pageInfo.pageName = `${errorCode}:${errorPageName}`;
    sendAnalyticsData('page_view');
    window.s.pageType = undefined;
  }
};
